import './assets/styles/main.scss';

import MsalAuthenticationProvider from '@shared/providers/MsalAuthenticationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';

import Host from './host';
import TelemetryListener from './telemetry/TelemetryListener';

declare global {
    interface Window {
        MPULSE: { ABTest: string };
    }
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
        },
    },
});

const HostRouter = () => {
    return (
        <>
            <QueryClientProvider client={queryClient}>
                <MsalAuthenticationProvider>
                    <TelemetryListener />
                    <HelmetProvider>
                        <Host />
                    </HelmetProvider>
                </MsalAuthenticationProvider>
            </QueryClientProvider>
        </>
    );
};

export default HostRouter;
